import { createAsyncThunk } from "@reduxjs/toolkit";
import { vehicleTypeApi } from "./api";

export const getVehicleTypeList = createAsyncThunk("get/vehicle-types", async () => {
  return await vehicleTypeApi.getList();
});
